import moment from 'moment';

export const BACKEND_DATE_FORMAT = 'YYYY-MM-DD';
export const CURRENT_WEEK_MOMENT = moment().week();
export const CURRENT_MONTH_MOMENT = moment().month();
